import React from "react";

export const IconCapacity = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 29 28"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m22.397 9.1875c-0.1602 2.2241-1.8102 3.9375-3.6094 3.9375s-3.4519-1.7128-3.6094-3.9375c-0.164-2.3138 1.4421-3.9375 3.6094-3.9375s3.7735 1.6658 3.6094 3.9375z"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m18.787 16.625c-3.564 0-6.9913 1.7702-7.8499 5.2177-0.1137 0.4561 0.1723 0.9073 0.641 0.9073h14.418c0.4687 0 0.7531-0.4512 0.641-0.9073-0.8586-3.5027-4.2859-5.2177-7.8504-5.2177z"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="m11.35 10.169c-0.128 1.7762-1.4613 3.1752-2.8984 3.1752-1.4372 0-2.7727-1.3984-2.8984-3.1752-0.1307-1.8479 1.167-3.1686 2.8984-3.1686 1.7314 0 3.0292 1.3546 2.8984 3.1686z"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m11.678 16.734c-0.9871-0.4522-2.0743-0.6261-3.2265-0.6261-2.8438 0-5.5836 1.4136-6.2699 4.1671-0.09023 0.3643 0.13836 0.7247 0.51242 0.7247h6.1403"
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconCapacity;
